import { styled, Typography } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const SectionTitle = styled(Typography)({
  fontWeight: 700,
  fontSize: '18px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '150%',
  textAlign: 'start',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
});

export default SectionTitle;
